import Svg, { Circle, Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgIconCheckmarkCircle = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 40 40" {...props}><Circle cx={15} cy={15.5} r={15} fill="currentColor" opacity={0.5} /><Path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="m8 15.59 4.588 4.91 8.412-9" /></Svg>;
const Memo = memo(SvgIconCheckmarkCircle);
export default Memo;